/*
 * Kuehn Doggear Theme: Parallaxe im stillen Moment (sections/start-moment.liquid).
 * Vorbild: components/moment.tsx (motion: useScroll -> useTransform).
 *
 * Das Bild ist bewusst hoeher als sein Rahmen (scale-[1.12] im Markup) und
 * wandert darin, AN den Scroll gekoppelt, von -5 % bis +5 % seiner Hoehe:
 * Fortschritt 0, wenn die Oberkante des Rahmens die Unterkante des Fensters
 * erreicht ("start end"), 1, wenn seine Unterkante die Oberkante des Fensters
 * verlaesst ("end start"). Dazwischen linear.
 *
 * Die Verschiebung steht als transform am Bild-Wrapper, die Vergroesserung als
 * eigene Eigenschaft scale in der Klasse; beides zusammen ergibt wie im
 * Original 5,6 % des Rahmens Weg bei 6 % Reserve je Kante.
 *
 * Ohne JavaScript und bei prefers-reduced-motion ruht das Bild. Gerechnet
 * wird nur, solange der Rahmen im Blick ist oder kurz davor steht
 * (IntersectionObserver mit einem halben Fenster Vorlauf), hoechstens einmal
 * je Bild (requestAnimationFrame); geschrieben wird nur transform.
 */
(function () {
  'use strict';

  /* Im Theme-Editor kann die Datei erneut ausgefuehrt werden: dann nur neu einsammeln. */
  if (window.KuehnMoment) {
    window.KuehnMoment.starten();
    return;
  }

  var WEG = 5; // Prozent der Bildhoehe, einmal nach oben, einmal nach unten
  var PASSIV = { passive: true };
  /* Ein halbes Fenster Vorlauf: der Stand stimmt, bevor der Rahmen zu sehen ist. */
  var VORLAUF = { rootMargin: '50% 0px' };

  var wenigBewegung = window.matchMedia('(prefers-reduced-motion: reduce)');
  var instanzen = [];

  function erzeugen(rahmen) {
    var bild = rahmen.querySelector('[data-moment-bild]');
    var stand = -1; // zuletzt gezeichneter Fortschritt
    var laeuft = false;
    var horcht = false;
    var bildId = 0;
    var beobachter = null;

    function zeichnen() {
      // lesen
      var flaeche = rahmen.getBoundingClientRect();
      var fenster = document.documentElement.clientHeight;
      var weg = fenster + flaeche.height;
      var p = weg > 0 ? Math.min(1, Math.max(0, (fenster - flaeche.top) / weg)) : 0;
      if (p === stand) return;
      stand = p;
      // schreiben
      bild.style.transform = 'translateY(' + (2 * WEG * p - WEG) + '%)';
    }

    function planen() {
      if (bildId || !laeuft) return;
      bildId = window.requestAnimationFrame(function () {
        bildId = 0;
        zeichnen();
      });
    }

    function horchen(ein) {
      if (ein === horcht) return;
      horcht = ein;
      var methode = ein ? 'addEventListener' : 'removeEventListener';
      window[methode]('scroll', planen, PASSIV);
      window[methode]('resize', planen, PASSIV);
      // Eigene Ebene nur in Reichweite: die Verschiebung kostet dann kein Neuzeichnen des Fotos.
      bild.style.willChange = ein ? 'transform' : '';
    }

    function an() {
      if (laeuft || wenigBewegung.matches || !bild) return;
      laeuft = true;
      zeichnen();
      if ('IntersectionObserver' in window) {
        beobachter = new IntersectionObserver(function (eintraege) {
          var nah = eintraege[eintraege.length - 1].isIntersecting;
          horchen(nah);
          // Kommt der Rahmen in Reichweite (auch nach einem Sprung ueber ihn hinweg), gilt der
          // Stand sofort; beim Verlassen steht der Fortschritt fest auf 0 oder 1.
          if (nah) zeichnen();
          else planen();
        }, VORLAUF);
        beobachter.observe(rahmen);
      } else {
        horchen(true);
      }
    }

    /* Zurueck zum ruhenden Bild. */
    function aus() {
      if (!laeuft) return;
      laeuft = false;
      if (beobachter) {
        beobachter.disconnect();
        beobachter = null;
      }
      horchen(false);
      if (bildId) {
        window.cancelAnimationFrame(bildId);
        bildId = 0;
      }
      bild.style.transform = '';
      stand = -1;
    }

    return { wurzel: rahmen, an: an, aus: aus };
  }

  /* Sammelt alle Momente im Bereich ein (ohne Angabe: im ganzen Dokument). */
  function starten(bereich) {
    instanzen = instanzen.filter(function (instanz) {
      if (document.documentElement.contains(instanz.wurzel)) return true;
      instanz.aus();
      return false;
    });
    var wurzeln = (bereich && bereich.querySelectorAll ? bereich : document).querySelectorAll('[data-moment]');
    Array.prototype.forEach.call(wurzeln, function (rahmen) {
      for (var i = 0; i < instanzen.length; i++) {
        if (instanzen[i].wurzel === rahmen) return;
      }
      var instanz = erzeugen(rahmen);
      instanzen.push(instanz);
      instanz.an();
    });
  }

  function beenden(bereich) {
    instanzen = instanzen.filter(function (instanz) {
      if (bereich && !bereich.contains(instanz.wurzel)) return true;
      instanz.aus();
      return false;
    });
  }

  function bewegungGeaendert() {
    instanzen.forEach(function (instanz) {
      if (wenigBewegung.matches) instanz.aus();
      else instanz.an();
    });
  }
  if (wenigBewegung.addEventListener) wenigBewegung.addEventListener('change', bewegungGeaendert);
  else if (wenigBewegung.addListener) wenigBewegung.addListener(bewegungGeaendert);

  /* Theme-Editor: Abschnitt neu aufbauen bzw. hinter ihm aufraeumen */
  document.addEventListener('shopify:section:load', function (e) {
    starten(e.target);
  });
  document.addEventListener('shopify:section:unload', function (e) {
    beenden(e.target);
  });

  window.KuehnMoment = { starten: starten, beenden: beenden };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      starten();
    });
  } else {
    starten();
  }
})();
